/*
 * サブシステム名：XXXX
 * 機能名：勤怠実績一覧
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'

const DdSearchList = () => import('@/components/DdSearchList')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox.vue')
const DdDateRangeBox = () => import('@/components/DdDateRangeBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdTextBox = () => import('../../components/DdTextBox.vue')

export default {
  name: 'PrmKintaiJissekiList',
  mixins: [flowMixin],
  components: {
    DdSearchList,
    DdCodeTextBox,
    DdTextBox,
    DdDateRangeBox,
    DdRadioButton
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,

    conditions: {
      kinmuYmdFromString: '',
      kinmuYmdToString: '',
      kintaiJissekiNo: '',
      jininId: '',
      jissekiKakuninZumiFlgKbn: '9',
      jissekiShimeFlgKbn: '9'
    },
    mstJininHeaders: header.mstJininHeaders,
    modeKengen: 0
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.kinmuYmdDisp = elem.kinmuYmd ? filter.dateFormatter(elem.kinmuYmd) : ''
        elem.shukkinYmdDisp = elem.shukkinYmd ? filter.dateFormatter(elem.shukkinYmd) : ''
        elem.taikinYmdDisp = elem.taikinYmd ? filter.dateFormatter(elem.taikinYmd) : ''
        elem.kinmuTeateKingaku1Disp = elem.kinmuTeateKingaku1 ? filter.numericFormatter(elem.kinmuTeateKingaku1) + '円' : ''
        elem.kinmuTeateKingaku2Disp = elem.kinmuTeateKingaku2 ? filter.numericFormatter(elem.kinmuTeateKingaku2) + '円' : ''
        elem.kinmuTeateKingaku3Disp = elem.kinmuTeateKingaku3 ? filter.numericFormatter(elem.kinmuTeateKingaku3) + '円' : ''
        elem.kinmuTeateKingaku4Disp = elem.kinmuTeateKingaku4 ? filter.numericFormatter(elem.kinmuTeateKingaku4) + '円' : ''
        elem.kinmuTeateKingaku5Disp = elem.kinmuTeateKingaku5 ? filter.numericFormatter(elem.kinmuTeateKingaku5) + '円' : ''
        elem.kinmuTeateKingaku6Disp = elem.kinmuTeateKingaku6 ? filter.numericFormatter(elem.kinmuTeateKingaku6) + '円' : ''
        elem.kinmuTeateKingaku7Disp = elem.kinmuTeateKingaku7 ? filter.numericFormatter(elem.kinmuTeateKingaku7) + '円' : ''
        elem.kinmuTeateKingaku8Disp = elem.kinmuTeateKingaku8 ? filter.numericFormatter(elem.kinmuTeateKingaku8) + '円' : ''
        elem.kinmuTeateKingaku9Disp = elem.kinmuTeateKingaku9 ? filter.numericFormatter(elem.kinmuTeateKingaku9) + '円' : ''
        elem.kinmuTeateKingaku10Disp = elem.kinmuTeateKingaku10 ? filter.numericFormatter(elem.kinmuTeateKingaku10) + '円' : ''
        elem.kosokuJikanDisp = elem.kosokuJikan ? this.calcTime(String(elem.kosokuJikan)) : ''
        elem.kadouJikanDisp = elem.kadouJikan ? this.calcTime(String(elem.kadouJikan)) : ''
        elem.kyukeiJikanDisp = elem.kyukeiJikan ? this.calcTime(String(elem.kyukeiJikan)) : ''
        elem.zangyoJikanDisp = elem.zangyoJikan ? this.calcTime(String(elem.zangyoJikan)) : ''
        elem.shinyaJikanDisp = elem.shinyaJikan ? this.calcTime(String(elem.shinyaJikan)) : ''
        elem.shinyaZangyoJikanDisp = elem.shinyaZangyoJikan ? this.calcTime(String(elem.shinyaZangyoJikan)) : ''
        if (elem.shukkinHms) { elem.shukkinHms = (elem.shukkinHms).slice(0, 5) }
        if (elem.taikinHms) { elem.taikinHms = (elem.taikinHms).slice(0, 5) }

        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredJininList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target &&
        (self.eigyoshoLockFlg || elem.eigyoshoCd === self.userEigyoshoCd)
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['vwcmsteigyoshojininlist'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('PrmKintaiJissekiList.defineHeaderPromise')
            self.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: '勤怠実績No', value: 'kintaiJissekiNo' },
              { text: '所属営業所', value: 'eighosyoNm' },
              { text: '人員', value: 'jininNm' },
              { text: '勤務年月日', value: 'kinmuYmdDisp', align: 'center' },
              { text: '登録担当者', value: 'torokuTantoshaNm' },
              { text: '実績確認済', value: 'jissekiKakuninZumiFlgNm' },
              { text: '実績締', value: 'jissekiShimeFlgNm' },
              // { text: '実績締ID', value: 'jissekiShimeId' },
              { text: '出勤年月日', value: 'shukkinYmdDisp', align: 'center' },
              { text: '出勤時刻', value: 'shukkinHms', align: 'center' },
              { text: '退勤年月日', value: 'taikinYmdDisp', align: 'center' },
              { text: '退勤時刻', value: 'taikinHms', align: 'center' },
              { text: '就労区分', value: 'shuroKbnNm' },
              { text: '勤務種類区分', value: 'kinmuKbnNm' },
              { text: '添乗', value: 'tenjoFlgNm' },
              // { text: '休日出勤種別', value: 'kyujitsuShukkinSbtNm' },
              { text: '拘束時間', value: 'kosokuJikanDisp', align: 'center' },
              { text: '実労働時間', value: 'kadouJikanDisp', align: 'center' },
              { text: '休憩時間', value: 'kyukeiJikanDisp', align: 'center' },
              { text: '残業時間', value: 'zangyoJikanDisp', align: 'center' },
              { text: '深夜時間', value: 'shinyaJikanDisp', align: 'center' },
              { text: '深夜残業時間', value: 'shinyaZangyoJikanDisp', align: 'center' },
              { text: '休日出勤区分', value: 'kyujitsuShukkinKbnNm' },
              { text: '残業手当', value: 'kinmuTeateKingaku1Disp', align: 'end' },
              { text: '深夜残業手当', value: 'kinmuTeateKingaku2Disp', align: 'end' },
              { text: '早深夜残業手当', value: 'kinmuTeateKingaku3Disp', align: 'end' },
              { text: '乗務手当', value: 'kinmuTeateKingaku4Disp', align: 'end' },
              { text: '作業手当', value: 'kinmuTeateKingaku5Disp', align: 'end' },
              { text: '長距離手当', value: 'kinmuTeateKingaku6Disp', align: 'end' },
              { text: '歩合手当', value: 'kinmuTeateKingaku7Disp', align: 'end' },
              { text: 'その他手当', value: 'kinmuTeateKingaku8Disp', align: 'end' },
              { text: '勤務手当金額9', value: 'kinmuTeateKingaku9Disp', align: 'end' },
              { text: '勤務手当金額10', value: 'kinmuTeateKingaku10Disp', align: 'end' },
              { text: '勤務手当ポイント1', value: 'kinmuTeatePoint1', align: 'end' },
              { text: '勤務手当ポイント2', value: 'kinmuTeatePoint2', align: 'end' },
              { text: '勤務手当ポイント3', value: 'kinmuTeatePoint3', align: 'end' },
              { text: '勤務手当ポイント4', value: 'kinmuTeatePoint4', align: 'end' },
              { text: '勤務手当ポイント5', value: 'kinmuTeatePoint5', align: 'end' },
              { text: '勤務手当ポイント6', value: 'kinmuTeatePoint6', align: 'end' },
              { text: '勤務手当ポイント7', value: 'kinmuTeatePoint7', align: 'end' },
              { text: '勤務手当ポイント8', value: 'kinmuTeatePoint8', align: 'end' },
              { text: '勤務手当ポイント9', value: 'kinmuTeatePoint9', align: 'end' },
              { text: '勤務手当ポイント10', value: 'kinmuTeatePoint10', align: 'end' },
              { text: '休憩時間(1回目)From', value: 'kyukeiJikan1From', align: 'center' },
              { text: '休憩時間(1回目)To', value: 'kyukeiJikan1To', align: 'center' },
              { text: '休憩時間(2回目)From', value: 'kyukeiJikan2From', align: 'center' },
              { text: '休憩時間(2回目)To', value: 'kyukeiJikan2To', align: 'center' },
              { text: '休憩時間(3回目)From', value: 'kyukeiJikan3From', align: 'center' },
              { text: '休憩時間(3回目)To', value: 'kyukeiJikan3To', align: 'center' },
              { text: '休憩時間(4回目)From', value: 'kyukeiJikan4From', align: 'center' },
              { text: '休憩時間(4回目)To', value: 'kyukeiJikan4To', align: 'center' },
              { text: '休憩時間(5回目)From', value: 'kyukeiJikan5From', align: 'center' },
              { text: '休憩時間(5回目)To', value: 'kyukeiJikan5To', align: 'center' },
              { text: '連絡用備考', value: 'renrakuBiko' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            const d = new Date()
            self.conditions = {
              kinmuYmdFromString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
              kinmuYmdToString: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
              kintaiJissekiNo: '',
              jininId: '',
              jissekiKakuninZumiFlgKbn: '9',
              jissekiShimeFlgKbn: '9'
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('PrmKintaiJissekiList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('PrmKintaiJissekiList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('PrmKintaiJissekiList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('TrKintaiJissekiList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('PrmKintaiJissekiList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      // 選択状態初期化
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCD2prmd1010/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload
          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              return {
              }
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    clear: function () {
      console.log('clear pushed')
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            const d = new Date()
            this.conditions = {
              kinmuYmdFromString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
              kinmuYmdToString: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
              kintaiJissekiNo: '',
              jininId: '',
              jissekiKakuninZumiFlgKbn: '9',
              jissekiShimeFlgKbn: '9'
            }
            this.searchText = ''
            this.rows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    },
    calcTime: function (p) {
      var result = ''
      if (p.indexOf(':') !== -1) {
        p = p.replace(':', '')
      }
      if (p.length < 3) {
        result = filter.minToIntervalTimeFormatter(parseInt(p, 10))
      } else {
        var min = parseInt(p.slice(0, p.length - 2), 10) * 60 + parseInt(p.slice(-2), 10)
        result = filter.minToIntervalTimeFormatter(min)
      }
      return result
    }
  }
}
